<template>
  <div class="select-filter">
    <span class="select-filter__label ms-help">{{ label }}:</span>
    <i-select
      v-model="value"
      :size="size || 'small'"
      style="width:160px"
      :filterable="filterable"
      not-found-text="Нет совпадений"
      :multiple="!!multiple"
    >
      <i-option
        v-for="item in items"
        :value="item.id"
        :key="item.id"
        :disabled="disabled"
        >{{
          item.id === "all" || item.id === "null" ? item.name : parseValue(item)
        }}</i-option
      >
    </i-select>
  </div>
</template>

<script>
export default {
  props: [
    'size',
    'type',
    'field',
    'label',
    'request',
    'values',
    'parse-value',
    'multiple',
    'filterable',
    'disabled'
  ],
  data () {
    return {
      items: this.values || []
    }
  },
  computed: {
    value: {
      get () {
        return this.$store.state.filters[this.type][this.field]
      },
      set (value) {
        this.$store.commit('CHANGE_FILTER', {
          type: this.type,
          field: this.field,
          value
        })
      }
    }
  },
  methods: {
    async getData () {
      try {
        const url = this.request
        const data = await this.$store.dispatch('GET_REQUEST', { url })

        this.items = this.getItems(data)
      } catch (error) {
        console.log(error)
      }
    },
    getItems (items) {
      if (this.type === 'experience') return items

      switch (this.field) {
        case 'manager':
        case 'field_manager':
          return [
            { id: 'all', name: 'Все' },
            { id: 'null', name: 'Не указан' },
            ...items.sort((a, b) => {
              const aName = this.parseValue(a)
              const bName = this.parseValue(b)

              if (aName > bName) return 1
              if (aName < bName) return -1
              return 0
            })
          ]
        default:
          return [{ id: 'all', name: 'Все' }, ...items]
      }
    }
  },
  created () {
    if (this.request) this.getData()
  }
}
</script>

<style lang="less">
.select-filter {
  display: flex;
  align-items: center;

  &:not(:first-child) {
    margin-left: 16px;
  }

  &__label {
    margin-right: 8px;
  }
}
</style>
